import { useQuery } from 'urql';
import { GET_LOANS_BY_OWNER, GET_LOAN_BY_ID, GET_LOAN_BY_OWNER, GET_LOAN_CLOSED_BY_LOAN, GET_LOAN_DOCUMENTS } from './graphql';
import { GetLoanByIdQuery, GetLoanByOwnerQuery, GetLoansByOwnerQuery, QueryGetLoanByIdArgs, QueryGetLoanDocByLoanArgs, QueryGetLoansByOwnerArgs, GetLoanDocByLoanQuery, QueryGetLoansClosedArgs, GetLoansClosedQuery } from 'gql/graphql';
import { UseQueryInterface } from '../../../@common/utils/interfaces/use-query.interface';

export const useGetLoanById = (variables: QueryGetLoanByIdArgs, query?: any) => {
  const [{ data, fetching, error }] = useQuery<GetLoanByIdQuery>({
    query: query || GET_LOAN_BY_ID,
    variables
  });
  return { data: data?.GetLoanById, fetching, error };
}

export const useGetLoanByOwner = (variables?: {}, query?: any) => {
  const [{ data, fetching, error }] = useQuery<GetLoanByOwnerQuery>({
    query: query || GET_LOAN_BY_OWNER,
    variables
  });
  return { data: data?.GetLoanByOwner?.loans, fetching, error };
}

export const useGetLoansByOwner = (vars?: UseQueryInterface<QueryGetLoansByOwnerArgs>) => {
  const [{ data, ...others }, reexecute] = useQuery<GetLoansByOwnerQuery>({
    query: vars?.query || GET_LOANS_BY_OWNER,
    ...vars
  });
  return {
    data: data?.GetLoansByOwner?.loans || [],
    totalCount: data?.GetLoansByOwner?.totalCount || 0,
    totalLoans: data?.GetLoansByOwner?.totalLoans || 0,
    hasMore: data?.GetLoansByOwner?.hasMore || false,
    currentPage: data?.GetLoansByOwner?.currentPage,
    tabTotals: data?.GetLoansByOwner?.tabTotals || { all: 0, error: 0 },
    reexecute,
    ...others
  };
};

export const useGetLoanDocByLoan = (vars?: UseQueryInterface<QueryGetLoanDocByLoanArgs>) => {
  const [{ data, ...others }, reexecute] = useQuery<GetLoanDocByLoanQuery>({
    query: vars?.query || GET_LOAN_DOCUMENTS,
    ...vars
  });
  return {
    data: data?.GetLoanDocByLoan,
    reexecute,
    ...others
  };
};

export const useGetLoanClosedByLoan = (vars?: UseQueryInterface<QueryGetLoansClosedArgs>) => {
  const [{ data, error }, reexecute] = useQuery<GetLoansClosedQuery>({
      query: vars?.query || GET_LOAN_CLOSED_BY_LOAN,
      ...vars
  });
  return {
      data: data?.GetLoansClosed,
      reexecute,
  };
};